export default {"src":"/_next/static/media/fourfourtwo.ec66c44d.svg","height":30,"width":118,"blurWidth":0,"blurHeight":0};